import { ApiResponse } from '@core/models/common.model';
import { AxiosResponse } from 'axios';
import { apiInstance } from 'config/api';

export const fetchLoginService = async ({
  document,
  password,
}: {
  document: string;
  password: string;
}) => {
  try {
    const response = await apiInstance.post('login', {
      document,
      password,
    });
    localStorage.setItem('token', response.data?.data?.token);
    return response.data;
  } catch (error: any) {
    if (!error.response) throw new Error('Ha ocurrido un error');
    throw new Error(JSON.stringify(error.response));
  }
};

export interface CheckinBody {
  user_id?: number;
  address: string;
  latitude: number;
  longitude: number;
  images: string[];
}

export interface CheckinResponse extends CheckinBody {
  id: number;
  images: string[];
  campaign_id: number;
  checkout_at?: string;
  status: 'active' | 'completed';
}

export const sendCheckIn = async (
  campaignId: number | string,
  body: CheckinBody
): Promise<AxiosResponse<ApiResponse<CheckinResponse>>> => {
  try {
    return await apiInstance.post<ApiResponse<CheckinResponse>>(
      `check-in/${campaignId}`,
      body
    );
  } catch (error: any) {
    throw new Error(error);
  }
};

export const sendCheckOut = async (
  checkInId: number
): Promise<AxiosResponse<ApiResponse<CheckinResponse>>> => {
  try {
    return await apiInstance.post<ApiResponse<CheckinResponse>>(
      `check-out/${checkInId}`
    );
  } catch (error: any) {
    throw new Error(error);
  }
};
